const PHONE = "0604026840";
const PHONE_DISPLAY = "06 04 02 68 40";

const services = [
  {
    id: 1,
    icon: "ri-door-open-line",
    title: "Ouverture de Porte",
    subtitle: "Urgence claquée / perdue",
    price: "À partir de 89€",
    description:
      "Porte claquée, clés perdues ou cassées dans la serrure ? Notre serrurier intervient en urgence à Créteil et dans tout le Val-de-Marne. Ouverture sans casse garantie.",
    features: ["Sans dégradation", "Intervention 20 min", "Disponible 24h/24"],
    accent: true,
  },
  {
    id: 2,
    icon: "ri-lock-2-line",
    title: "Serrure Connectée",
    subtitle: "Installation & configuration",
    price: "Sur devis",
    description:
      "Installation et configuration de serrures connectées (Nuki, Yale, Somfy). Sécurisez votre domicile avec une serrure intelligente pilotable depuis votre smartphone.",
    features: ["Marques certifiées", "Configuration incluse", "Garantie 2 ans"],
    accent: false,
  },
  {
    id: 3,
    icon: "ri-car-line",
    title: "Ouverture de Voiture",
    subtitle: "Clés enfermées / perdues",
    price: "À partir de 79€",
    description:
      "Clés enfermées dans votre véhicule ? Nous intervenons rapidement pour ouvrir votre voiture sans dégradation, quelle que soit la marque ou le modèle.",
    features: ["Toutes marques", "Sans dégradation", "Devis gratuit"],
    accent: false,
  },
  {
    id: 4,
    icon: "ri-shield-keyhole-line",
    title: "Blindage de Porte",
    subtitle: "Sécurisation renforcée",
    price: "Sur devis",
    description:
      "Renforcez la sécurité de votre logement avec un blindage de porte certifié. Protection contre l'effraction, idéal après un cambriolage ou pour prévenir les risques.",
    features: ["Certification A2P", "Pose rapide", "Garantie fabricant"],
    accent: false,
  },
  {
    id: 5,
    icon: "ri-tools-line",
    title: "Changement de Serrure",
    subtitle: "Remplacement & mise à niveau",
    price: "À partir de 120€",
    description:
      "Remplacement de serrure suite à un cambriolage, déménagement ou serrure défectueuse. Pose de serrures multipoints haute sécurité certifiées.",
    features: ["Serrures 3 points", "Marques premium", "Pose incluse"],
    accent: false,
  },
  {
    id: 6,
    icon: "ri-building-line",
    title: "Serrurerie Professionnelle",
    subtitle: "Entreprises & copropriétés",
    price: "Sur devis",
    description:
      "Interventions pour professionnels, syndics et copropriétés dans le Val-de-Marne. Contrats de maintenance, badges d'accès, digicodes et systèmes de contrôle d'accès.",
    features: ["Contrats maintenance", "Contrôle d'accès", "Devis rapide"],
    accent: false,
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-white relative overflow-hidden">
      {/* Subtle diagonal pattern */}
      <div
        className="absolute inset-0 opacity-[0.02] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #FFB100 0px, #FFB100 4px, transparent 4px, transparent 40px)",
        }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#FFB100]/10 text-[#FFB100] text-xs font-bold px-3 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            <i className="ri-tools-line"></i>
            Nos prestations
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-black uppercase leading-tight mb-3">
            Services de Serrurerie
            <br />
            <span className="text-[#FFB100]">d&apos;Urgence</span>
          </h2>
          <p className="text-gray-500 text-base max-w-xl">
            Intervention rapide 24h/24 et 7j/7 à Créteil et dans tout le Val-de-Marne. Devis gratuit par téléphone.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <div
              key={service.id}
              className={`rounded-2xl overflow-hidden border transition-all hover:-translate-y-1 duration-300 ${
                service.accent
                  ? "border-[#FFB100] bg-black text-white"
                  : "border-gray-100 bg-white text-black"
              }`}
            >
              {/* Icon area */}
              <div
                className={`px-6 pt-6 pb-4 flex items-center gap-4 ${
                  service.accent ? "" : ""
                }`}
              >
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${
                    service.accent ? "bg-[#FFB100]" : "bg-[#FFB100]/10"
                  }`}
                >
                  <i
                    className={`${service.icon} text-2xl ${
                      service.accent ? "text-black" : "text-[#FFB100]"
                    }`}
                  ></i>
                </div>
                <div>
                  <h3
                    className={`font-black text-base leading-tight ${
                      service.accent ? "text-white" : "text-black"
                    }`}
                  >
                    {service.title}
                  </h3>
                  <p
                    className={`text-xs mt-0.5 ${
                      service.accent ? "text-[#FFB100]" : "text-gray-400"
                    }`}
                  >
                    {service.subtitle}
                  </p>
                </div>
              </div>

              <div className="px-6 pb-6">
                <p
                  className={`text-sm leading-relaxed mb-4 ${
                    service.accent ? "text-gray-300" : "text-gray-500"
                  }`}
                >
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-1.5 mb-5">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i
                          className={`ri-check-line text-sm ${
                            service.accent ? "text-[#FFB100]" : "text-[#FFB100]"
                          }`}
                        ></i>
                      </div>
                      <span className={service.accent ? "text-gray-300" : "text-gray-600"}>
                        {f}
                      </span>
                    </li>
                  ))}
                </ul>

                {/* CTA */}
                <a
                  href={`tel:${PHONE}`}
                  className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                    service.accent
                      ? "bg-[#FFB100] text-black hover:bg-yellow-400"
                      : "bg-black text-white hover:bg-gray-800"
                  }`}
                >
                  <i className="ri-phone-line"></i>
                  Appeler
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Besoin d&apos;un devis ou d&apos;une intervention immédiate ?
          </p>
          <a
            href={`tel:${PHONE}`}
            className="inline-flex items-center gap-2 bg-[#FFB100] text-black font-black text-sm md:text-base px-5 md:px-8 py-3 md:py-4 rounded-full hover:bg-yellow-400 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-base md:text-xl"></i>
            <span className="hidden sm:inline">Appeler le {PHONE_DISPLAY} — Devis gratuit</span>
            <span className="sm:hidden">Devis gratuit — {PHONE_DISPLAY}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
